
import React from 'react';

interface ChartAttributionProps {
  width: number;
  websiteTextY: number;
  websiteTextFontSize: number;
}

export const ChartAttribution: React.FC<ChartAttributionProps> = ({ 
  width, 
  websiteTextY, 
  websiteTextFontSize 
}) => {
  // Website attribution text
  const websiteText = "con-ver-gence.com";

  return (
    <text 
      x={width/2} 
      y={websiteTextY} 
      fill="#FFFFFF" 
      data-fill-variable="--foreground"
      fontSize={websiteTextFontSize}
      textAnchor="middle"
      fontFamily="'Inter', 'Helvetica', 'Arial', sans-serif"
    >
      {websiteText}
    </text>
  );
};
